import Repository from "@/services/repositories/Repository";
import {empty} from "@/shared/utils";

export default {
    get() {
        return Repository.get('newsletter/campaigns')
    },
    getCampaign(campaignId) {
        return Repository.get('newsletter/campaign/'+campaignId)
    },
    createCampaign(campaign) {
        let listings = [];
        campaign.listings.forEach((value) => {
          listings.push({
            listingId: value.id
          })
        });

        return Repository.post(
            'newsletter/campaign',
            {
                title: campaign.title,
                subject: campaign.subject,
                mailShotHtml: campaign.mailShotHtml,
                listings: listings,
                sendAt: campaign.sendAt
            }
        )
    },
    searchCampaigns(search) {
        let query = '?'

        if (!empty(search.title)) {
            query += '&title='+search.title
        }
        if (!empty(search.status)) {
            query += '&statuses[]=' + search.status
        }

        return Repository.get('newsletter/campaigns' + query)
    },
    updateCampaign(campaign) {
        return Repository.put(
            'newsletter/campaign/' + campaign.id,
            {
                title: campaign.title,
                subject: campaign.subject
            }
        )
    },
    cancelCampaign(campaignId) {
        return Repository.post('newsletter/campaign/' + campaignId + '/cancel')
    },
    scheduleCampaign(campaignId) {
      return Repository.post('newsletter/campaign/' + campaignId + '/schedule')
    },
    sendCampaign(campaignId) {
      return Repository.post('newsletter/campaign/' + campaignId + '/send')
    }
}
